function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.787 17.333l-3.067 3.054a1.336 1.336 0 00.434 2.185 1.334 1.334 0 001.46-.292l5.333-5.333c.121-.127.216-.277.28-.44a1.334 1.334 0 000-1.014 1.333 1.333 0 00-.28-.44L15.614 9.72a1.34 1.34 0 00-1.894 1.893l3.067 3.054H4a1.333 1.333 0 000 2.666h12.787zM16 2.667a13.333 13.333 0 00-12 7.4 1.342 1.342 0 002.4 1.2 10.667 10.667 0 119.6 15.4 10.574 10.574 0 01-9.546-5.934 1.341 1.341 0 10-2.4 1.2A13.334 13.334 0 1016 2.667z"
});

function SvgSignOutAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#fff"
  }, props), _ref);
}

export default SvgSignOutAlt;